<form
  #companyForm="ngForm"
  id="forms.companyForm"
  role="form"
  name="forms.companyForm"
  (ngSubmit)="save()"
  autocomplete="on"
  novalidate
>
  <main>
    <div rvSpinner="company-settings" [rvShowSpinner]="companyService.loading" class="settings-page-container">
      <div class="company-settings settings-page-body">
        <company-fields [company]="companyService.company" showManagedSections="true"
          (resetAuthKeyEvent)="resetAuthKey()"
          (resetClaimIdEvent)="resetClaimId()"
        ></company-fields>
      </div>
      <div class="settings-page-footer">
        <common-actions
          [actions]="actions"
          [saving]="companyService.loading"
          [changeDate]="companyService.company?.changeDate"
          [changedBy]="companyService.company?.changedBy">
        </common-actions>
      </div>
    </div>
  </main>
</form>
